import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'; // Import useDispatch
import AdminHomeHelper from '../../../Components/AdminHomeHelper';
import { updateStudent } from '../../../redux/action/adminAction';


const AdminStudentView = () => {
  const { studentId } = useParams();
  const student = useSelector((store) => {
    return store.admin.allStudent.find((student) => student._id === studentId);
  });
  const [name, setName] = useState(student ? student.name : '');
  const [email, setEmail] = useState(student ? student.email : '');
  const [registrationNumber, setRegistrationNumber] = useState(student ? student.registrationNumber : '');
  const [department, setDepartment] = useState(student ? student.department : '');
  const [year, setYear] = useState(student ? student.year : '');
  const [semester, setSemester] = useState(student ? student.semester : '');
  const [section, setSection] = useState(student ? student.section : '');
  const [branch, setBranch] = useState(student ? student.branch : '');
  const [dob, setDob] = useState(student ? student.dob : '');
  const [gender, setGender] = useState(student ? student.gender : '');
  const [studentMobileNumber, setContactNumber] = useState(student ? student.studentMobileNumber : '');
  const [fatherName, setFatherName] = useState(student ? student.fatherName : '');
  const [fatherMobileNumber, setFatherMobileNumber] = useState(student ? student.fatherMobileNumber : '');
  const [aadharCard, setAadharCard] = useState(student ? student.aadharCard : '');
  const [bloodGroup, setBloodGroup] = useState(student ? student.bloodGroup : '');
  const [emisNumber, setEmisNumber] = useState(student ? student.emisNumber : '');
  const [Religion, setReligion] = useState(student ? student.Religion : '');
  const [Community, setCommunity] = useState(student ? student.Community : '');
  const [FirstGraduate, setFirstGraduate] = useState(student ? student.FirstGraduate : '');
  const [SpecialAdmission, setSpecialAdmission] = useState(student ? student.SpecialAdmission : '');
  const [motherName, setMotherName] = useState(student ? student.motherName : '');
  const [fatherOccupation, setFatherOccupation] = useState(student ? student.fatherOccupation : '');
  const [MotherOccupation, setMotherOccupation] = useState(student ? student.MotherOccupation : '');
  const [AnnualIncome, setAnnualIncome] = useState(student ? student.AnnualIncome : '');
  const [BankAccountNumber, setBankAccountNumber] = useState(student ? student.BankAccountNumber : '');
  const [IFSCcode, setIfscCode] = useState(student ? student.IFSCcode : '');
  const [BankName, setBankName] = useState(student ? student.BankName : '');
  const [BankBranch, setBankBranch] = useState(student ? student.BankBranch : '');
  const [AcademicYear, setAcademicYear] = useState(student ? student.AcademicYear : '');
  const [DateOfadmission, setDateOfAdmission] = useState(student ? student.DateOfadmission : '');
  const [TypeOfAdmission, setTypeOfAdmission] = useState(student ? student.TypeOfAdmission : '');
  const [CounselingNumber, setCounselingNumber] = useState(student ? student.CounselingNumber : '');
  const [lateralEntry, setLateralEntry] = useState(student ? student.lateralEntry : '');
  const [Hosteller, setHosteller] = useState(student ? student.Hosteller : '');
  const [address, setAddress] = useState(student ? student.address : '');
  const [status, setStatus] = useState(student ? student.status : '');
  const [avatar, setAvatar] = useState(student ? student.avatar : '');
  const dispatch = useDispatch()
  

  const handleUpdateStudent = (updatedData) => {
    const confirmation = window.confirm('Are you sure you want to update this student?');
  
    if (confirmation) {
      dispatch(updateStudent(studentId, updatedData))
        .then(() => {
          alert('Student updated successfully');
          window.location.href = '/admin/allStudents'; // Redirect to the desired URL
        })
        .catch((error) => {
          alert('Failed to update student');
          console.error(error);
        });
    }
  };
  const [previewImage, setPreviewImage] = useState(student.avatar);
  const imagehandler = (e) => {
    if (e.target.files && e.target.files[0]) {
        let img = e.target.files[0]
        setAvatar(img)
        console.log(img)
        const imageURL = URL.createObjectURL(img);
        setPreviewImage(imageURL);
    }
}
  
  
  return (
    <div>
   <div className="container-fluid p-0">
            <div className="d-flex">
                <div className="print-helper">
                    <AdminHomeHelper />
                </div>
                <div className="mx-1 w-100 ">
                    <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                        <h5><Link to='/admin/allStudents' className='text-light'><img src="/image/Back.svg" className='p-2' alt="" /></Link></h5>
                        <h3> <img src="/logo192.png" width={'50px'} alt="" />Update Student</h3>
                        <button  onClick={()=> window.print()} type="button" className="print-helper btn-success btn text-light"> <img src="/image/print.svg" lt="" /> <span className=''>Download</span></button>
                    </div>
                    <div className=" w-100 bg-light d-md-flex align-items-center justify-content-between">
                            <div className="stuData  w-100">
                                <div className="row">
                            <div className='sortDetails overflow-hidden col-md-4'>
                            <form
                              onSubmit={(e) => {
                                e.preventDefault();
                                const formData = new FormData();
                                formData.append("avatar", avatar);
                                handleUpdateStudent(formData); // Pass formData to your update function
                              }}
                            >
                              <input
                                required
                                className="form-control"
                                type="file"
                                accept=".jpg,.png,.jpeg"
                                id="inputId"
                                onChange={imagehandler}
                              ></input>
                              {avatar && <img src={previewImage} alt="Current Avatar" width="200" />} <br />
                              <button type='submit' className='btn btn-success'>Update</button>
                            </form>
                                <h5 className='bg-dark text-light p-1 w-100'>{student.name}</h5>
                                <div className="w-100">
                                    <h6 className='d-flex align-items-center'><img src="/image/mail.svg" alt="" className='p-1' />{student.email}</h6>
                                    <h6 className='d-flex align-items-center'><img src="/image/phone.svg" alt="" className='p-1' />{student.studentMobileNumber}</h6>
                                </div>
                            </div>
                            <div className="table-responsive w-100 col-md-8">
                                   <table className="table shTable table-striped table-bordered">
                                   <tbody>
                                   <tr>
                                      <td>Name</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ name: name });
                                          }}
                                        >
                                          <input
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            type="text"
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Email</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ email: email });
                                          }}
                                        >
                                          <input
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            type="text"
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Registration Number</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ registrationNumber: registrationNumber });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={registrationNumber}
                                            onChange={(e) => setRegistrationNumber(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Student Status</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ status: status });
                                          }}
                                        >
                                          <select onChange={(e)=> setStatus(e.target.value)}>
                                          <option>Select</option>
                                            <option value="active">active</option>
                                            <option value="irregular">irregular</option>
                                            <option value="Passed Out">Passed Out</option>
                                          </select>
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Date Of Birth</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ dob: dob });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={dob}
                                            onChange={(e) => setDob(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Year</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ year: year });
                                          }}
                                        >
                                           <select onChange={(e) => setYear(e.target.value)} value={year}>
                                            <option>Select</option>
                                            <option value="I">1</option>
                                            <option value="II">2</option>
                                            <option value="III">3</option>
                                            <option value="IV">4</option>
                                        </select>
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Semester</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ semester: semester });
                                          }}
                                        >
                                          <select
                                            onChange={(e) => setSemester(e.target.value)} value={semester}>
                                            <option>Select</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                        </select>
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Department</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ department: department });
                                          }}
                                        >
                                         <select onChange={(e) => setDepartment(e.target.value)} value={department}>
                                            <option>Select</option>
                                            <option value="ECE">ECE</option>
                                            <option value="CSE">CSE</option>
                                            <option value="AIDS">AIDS</option>
                                            <option value="EEE">EEE</option>
                                            <option value="MECH">MECH</option>
                                            <option value="CIVIL">CIVIL</option>
                                                <option value="BIO">BIO</option>
                                                <option value="AGRI">AGRI</option>
                                                <option value="MBA">MBA</option>
                                                <option value="MCA">MCA</option>
                                        </select>
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Section</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ section: section });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={section}
                                            onChange={(e) => setSection(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Branch</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ branch: branch });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={branch}
                                            onChange={(e) => setBranch(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Gender</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ gender: gender });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={gender}
                                            onChange={(e) => setGender(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Contact Number</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ studentMobileNumber: studentMobileNumber });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={studentMobileNumber}
                                            onChange={(e) => setContactNumber(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Blood group</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ bloodGroup: bloodGroup });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={bloodGroup}
                                            onChange={(e) => setBloodGroup(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>EMIS Number</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ emisNumber: emisNumber });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={emisNumber}
                                            onChange={(e) => setEmisNumber(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Religion</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ Religion: Religion });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={Religion}
                                            onChange={(e) => setReligion(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Community</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ Community: Community });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={Community}
                                            onChange={(e) => setCommunity(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Aadhar number</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ aadharCard: aadharCard });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={aadharCard}
                                            onChange={(e) => setAadharCard(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>First graduate</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ FirstGraduate: FirstGraduate });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={FirstGraduate}
                                            onChange={(e) => setFirstGraduate(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Special admission</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ SpecialAdmission: SpecialAdmission });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={SpecialAdmission}
                                            onChange={(e) => setSpecialAdmission(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Permanent address</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ address: address });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Father's name</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ fatherName: fatherName });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={fatherName}
                                            onChange={(e) => setFatherName(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Father's occupation</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ fatherOccupation: fatherOccupation });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={fatherOccupation}
                                            onChange={(e) => setFatherOccupation(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Mother's name</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ motherName: motherName });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={motherName}
                                            onChange={(e) => setMotherName(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Mother’s occupation</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ MotherOccupation: MotherOccupation });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={MotherOccupation}
                                            onChange={(e) => setMotherOccupation(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Parent Contact Number</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ fatherMobileNumber: fatherMobileNumber });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={fatherMobileNumber}
                                            onChange={(e) => setFatherMobileNumber(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Annual family income</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ AnnualIncome: AnnualIncome });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={AnnualIncome}
                                            onChange={(e) => setAnnualIncome(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Bank account number</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ BankAccountNumber: BankAccountNumber });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={BankAccountNumber}
                                            onChange={(e) => setBankAccountNumber(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>IFSC code</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ IFSCcode: IFSCcode });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={IFSCcode}
                                            onChange={(e) => setIfscCode(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Bank name</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ BankName: BankName });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={BankName}
                                            onChange={(e) => setBankName(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Bank branch</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ BankBranch: BankBranch });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={BankBranch}
                                            onChange={(e) => setBankBranch(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Academic year of joining</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ AcademicYear: AcademicYear });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={AcademicYear}
                                            onChange={(e) => setAcademicYear(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Date of admission</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ DateOfadmission: DateOfadmission });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={DateOfadmission}
                                            onChange={(e) => setDateOfAdmission(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Type of admission</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ TypeOfAdmission: TypeOfAdmission });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={TypeOfAdmission}
                                            onChange={(e) => setTypeOfAdmission(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Counseling Number</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ CounselingNumber: CounselingNumber });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={CounselingNumber}
                                            onChange={(e) => setCounselingNumber(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>lateral entry</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ lateralEntry: lateralEntry });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={lateralEntry}
                                            onChange={(e) => setLateralEntry(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Hosteller</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStudent({ Hosteller: Hosteller });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={Hosteller}
                                            onChange={(e) => setHosteller(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>                                                                        
                                    </tbody>
                                    </table>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  );
};

export default AdminStudentView;